import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { HeatingDeviceConfig } from 'console/shared/contexts/heating-device/config/types';
import { autoHeatingModeIcon, custom_heating_modes_icons, } from 'z3k-settings/components/heating-modes/icons';
export const ModeIcon = (props) => {
    const { id, name, large = false, ...rest } = props;
    const { heating_modes_icons } = useContext(HeatingDeviceConfig);
    const mode_icon = useMemo(() => (heating_modes_icons && id ? heating_modes_icons[id] : null), [heating_modes_icons, id]);
    const icon = useMemo(() => custom_heating_modes_icons.find((settings_icon) => settings_icon.id === mode_icon), [custom_heating_modes_icons, mode_icon]);
    const heating_mode_icon = useMemo(() => {
        if (icon) {
            return icon.render;
        }
        if (!name) {
            return null;
        }
        return autoHeatingModeIcon(name).render;
    }, [name, icon]);
    return (_jsx(ResponsiveIcon, { large: large, color: "inherit", Icon: heating_mode_icon, width: "32", height: "32", viewBox: "0 0 32 36", ...rest }));
};
